import NewSwitch from "pages/business/Subscription/NewSwitch";
import SettingsBasicSelect from "../../../components/Shared/SettingsBasicSelect";
import {useSelector} from "react-redux";
import BasicButton from "../../../components/BasicInputs/BasicButton";
import {apiSetAlert} from "../../../api/appApi";
import {copyToClipboard} from "../../../helpers";
import CopyImg from "../../../assets/images/Copy.svg";
import {Typography} from "@mui/material";
import Postman from "../../../assets/svg/postman.svg";
import {NotAvailable} from "../../../components/Profile/profileInner/ChortkeOffline";
import {useNavigate} from "react-router-dom";

function SendSmsSetting(props: any) {
  const navigate = useNavigate()
  // @ts-ignore
  const { business, token } = useSelector((state) => state).businessReducer.business;

  const { settingData, setSettingData } = props;

  const onChange = (key: any, value: any) => {
    let temp = {
      ...settingData,
      [key]: value,
    };
    setSettingData(temp);
  };

  const selectedItem = (options: any, key: any, defaultLabel: string) => {
    const keyValue = settingData[key];
    const placeHolder = options.find((i: { value: any }) => i.value == keyValue);

    return placeHolder?.label || defaultLabel;
  };

  return (
    <div className="flex container flex-col ">
      {business.subscription && ![7, 10, 13, 17, 21, 25].includes(business.subscription.id) ? (
          <>
            <div className="flex flex-col w-full mb-10">
              <span className="text-[#7E8C9E]">ارسال به صاحب کسب و کار</span>
            </div>
            {notificationDefaultData.map((item, index) => (
                <div key={index} className="flex flex-row items-center w-full py-4 mb-6">
                  <NewSwitch
                      active={settingData[item.key] || undefined}
                      activeColor="#30D74B"
                      size={2}
                      onChange={(value) => onChange(item.key, value)}
                  />
                  <span className="text-base mr-4 color-[#424242]">{item.label}</span>
                  <div className="flex-1 flex justify-end">
                    {item.timeSetting && (
                        <SettingsBasicSelect
                            options={item.timeSetting.options}
                            onChange={(val) => {
                              onChange(item.timeSetting.key, val);
                            }}
                            placeholder={selectedItem(
                                item.timeSetting.options,
                                item.timeSetting.key,
                                item.timeSetting.options[0].label
                            )}
                        />
                    )}
                  </div>
                </div>
            ))}
            <div className="flex flex-col w-full mb-10">
              <span className="text-[#7E8C9E]">ارسال به مشتریان</span>
            </div>
            {defaultData.map((item, index) => (
                <div key={index} className="flex flex-row items-center w-full py-4 mb-6">
                  <NewSwitch
                      active={settingData[item.key] || undefined}
                      activeColor="#30D74B"
                      size={2}
                      onChange={(value) => onChange(item.key, value)}
                  />
                  <span className="text-base mr-4 color-[#424242]">{item.label}</span>
                  <div className="flex-1 flex justify-end">
                    {item.timeSetting && (
                        <SettingsBasicSelect
                            //@ts-ignore
                            options={item.timeSetting.options}
                            onChange={(val) => {
                              //@ts-ignore
                              onChange(item.timeSetting.key, val);
                            }}
                            placeholder={selectedItem(
                                //@ts-ignore
                                item.timeSetting.options,
                                //@ts-ignore
                                item.timeSetting.key,
                                //@ts-ignore
                                item.timeSetting.options[0].label
                            )}
                        />
                    )}
                  </div>
                </div>
                // <div
                //   key={index}
                //   className="flex flex-row items-center w-full border border-[#c2d1e3] rounded-md py-5 px-5 mb-6"
                // >
                //   <NotificationIcon />
                //   <div className="flex  flex-1 flex-row items-center justify-between mr-4">
                //     <div className="flex flex-col">
                //       <div className="flex flex-row items-center">
                //         <span className="text-base color=[#424242]">{item.title}</span>
                //         {/* <button className="flex bg-[#FEFEFE] flex-row item-center mr-6 ">
                //           <Pencel />
                //           <span className="text-blue-1  mr-1 text-xs">ویرایش محتوا پیامک</span>
                //         </button> */}
                //       </div>
                //       <span className="text-dark-3 text-xs mt-3 ">{item.description}</span>
                //     </div>
                //     <div>
                //       <NewSwitch
                //         onChange={(value) => onChange(item.key, value)}
                //         active={settingData[item.key] || undefined}
                //         activeColor="#30D74B"
                //         size={2}
                //       />
                //     </div>
                //   </div>
                // </div>
            ))}
            <div className="flex flex-col w-full my-10">
              <span className="text-[#7E8C9E]">ارسال به کاربران</span>
            </div>
            {userData.map((item, index) => (
                <div key={index} className="flex flex-row items-center w-full py-4 mb-6">
                  <NewSwitch
                      active={settingData[item.key] || undefined}
                      activeColor="#30D74B"
                      size={2}
                      onChange={(value) => onChange(item.key, value)}
                  />
                  <span className="text-base mr-4 color-[#424242]">{item.label}</span>
                  <div className="flex-1 flex justify-end"></div>
                </div>
                // <div
                //   key={index}
                //   className="flex flex-row items-center w-full border border-[#c2d1e3] rounded-md py-5 px-5 mb-6"
                // >
                //   <NotificationIcon />
                //   <div className="flex  flex-1 flex-row items-center justify-between mr-4">
                //     <div className="flex flex-col">
                //       <div className="flex flex-row items-center">
                //         <span className="text-base color=[#424242]">{item.title}</span>
                //         {/* <button className="flex bg-[#FEFEFE] flex-row item-center mr-6 ">
                //           <Pencel />
                //           <span className="text-blue-1  mr-1 text-xs">ویرایش محتوا پیامک</span>
                //         </button> */}
                //       </div>
                //       <span className="text-dark-3 text-xs mt-3 ">{item.description}</span>
                //     </div>
                //     <div>
                //       <NewSwitch
                //         onChange={(value) => onChange(item.key, value)}
                //         active={settingData[item.key] || undefined}
                //         activeColor="#30D74B"
                //         size={2}
                //       />
                //     </div>
                //   </div>
                // </div>
            ))}
          </>
      ) : (
          <>
            <Typography color="#666666" sx={{ mb: 3 }}>
              استفاده از پنل پیامکی برای اشتراک شما فعال نشده است. برای فعالسازی باید اشتراک خود را
              ارتقاء دهید
            </Typography>
            <NotAvailable handleClick={() => navigate("/business/extend")} />
          </>
      )}
    </div>
  );
}

export default SendSmsSetting;
const optionConst: {
  id: number;
  label: string;
  value: string;
}[] = [
  {
    id: 0,
    label: "همان روز",
    value: "0",
  },
  {
    id: 1,
    label: "روز قبل",
    value: "1",
  },
  {
    id: 2,
    label: "سه روز قبل",
    value: "3",
  },
  {
    id: 3,
    label: "یک هفته قبل",
    value: "7",
  },
];

const defaultData = [
  // {
  //   label: "دعوت مشتریان به پنل حسابداری",
  //   description: "ارسال اطلاعات کارت حساب اشخاص",
  //   key: "inviteUserSMS",
  //   timeSetting: null,
  // },
  {
    label: "اعلام صدور پیش فاکتور به مشتری",
    description: "ارسال اطلاعات کارت حساب اشخاص",
    key: "invoiceSendSMS",
    timeSetting: null,
  },
  {
    label: "اعلام ثبت نهایی فاکتور به مشتری",
    description: "ارسال اطلاعات کارت حساب اشخاص",
    key: "factorCreateSMS",
    timeSetting: null,
  },
  {
    label: "اعلام سر رسید چک دریافتی به مشتری",
    description: "ارسال اطلاعات کارت حساب اشخاص",
    key: "receiveChequeDueDateCustomerSms",
    timeSetting: {
      key: "receiveChequeDueDateCustomerSmsTime",
      options: optionConst,
    },
  },
  {
    label: "اعلام سر رسید قسط دریافتی به مشتری",
    description: "ارسال اطلاعات کارت حساب اشخاص",
    key: "receiveInstallmentItemDueDateCustomerSms",
    timeSetting: {
      key: "receiveInstallmentItemDueDateCustomerSmsTime",
      options: optionConst,
    },
  }
  // {
  //   label: "ارسال پیامک سر رسید اقساط",
  //   key: "installmentDueDateSms",
  //
  //   timeSetting: {
  //     key: "installmentDueDateSmsTime",
  //     options: optionConst,
  //   },
  // },
  // {
  //   title: "ارسال لینک پرداخت سفارش به مشتری",
  //   description: "ارسال اطلاعات کارت حساب اشخاص",
  //   key: "customerPaymentLinkSMS",
  // },
  // {
  //   title: "ارسال صورت حساب آنلاین",
  //   description: "ارسال اطلاعات کارت حساب اشخاص",
  //   key: "onlinePaymentSMS",
  // },
];

const userData = [
  {
    label: "خوش آمدگویی کاربران سیستم",
    description: "پیامک دعوت کاربران کسب و کار به ثبت نام در چرتکه",
    key: "welcomeMessageSMS",
    timeSetting: null,
  },
];

const notificationDefaultData = [
  {
    label: "ارسال پیامک سررسید فاکتور فروش",
    key: "sellFactorDueDateSms",
    timeSetting: {
      key: "sellFactorDueDateSmsTime",
      options: optionConst,
    },
  },
  {
    label: "ارسال پیامک سررسید فاکتور خرید",
    key: "buyFactorDueDateSms",
    timeSetting: {
      key: "buyFactorDueDateSmsTime",
      options: optionConst,
    },
  },
  {
    label: "ارسال پیامک سررسید چک دریافتی",
    key: "receiveChequeDueDateSms",
    timeSetting: {
      key: "receiveChequeDueDateSmsTime",
      options: optionConst,
    },
  },
  {
    label: "ارسال پیامک سررسید چک پرداختی",
    key: "paymentChequeDueDateSms",
    timeSetting: {
      key: "paymentChequeDueDateSmsTime",
      options: optionConst,
    },
  },
  {
    label: "ارسال پیامک سر رسید اقساط دریافتی",
    key: "receiveInstallmentDueDateSms",

    timeSetting: {
      key: "receiveInstallmentDueDateSmsTime",
      options: optionConst,
    },
  },
  {
    label: "ارسال پیامک سر رسید اقساط پرداختی",
    key: "paymentInstallmentDueDateSms",

    timeSetting: {
      key: "paymentInstallmentDueDateSmsTime",
      options: optionConst,
    },
  },
];

const NotificationIcon = () => (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y=".5" width="40" height="40" rx="4" fill="#D6E4FF" />
    <path
      d="M23.021 12.328a.643.643 0 0 0 1.243.333l.554-2.07a.644.644 0 0 0-.946-.74.643.643 0 0 0-.295.407l-.556 2.07Zm6.219-1.068a.643.643 0 0 1 0 .909l-2.143 2.142a.643.643 0 0 1-.909-.908l2.143-2.143a.643.643 0 0 1 .909 0Zm-1.954 5.599a.643.643 0 0 1 .642-.643h2.143a.643.643 0 1 1 0 1.286h-2.143a.643.643 0 0 1-.642-.643Zm-7.073 13.927a4.069 4.069 0 0 1-3.486-1.968l-1.723.862a2.357 2.357 0 0 1-2.721-.442l-1.02-1.02a2.358 2.358 0 0 1-.442-2.72l6.133-12.267a2.357 2.357 0 0 1 3.774-.612l7.153 7.153a2.357 2.357 0 0 1-.613 3.775l-3.28 1.64a4.071 4.071 0 0 1-3.774 5.599Zm2.62-5.02-4.951 2.474a2.786 2.786 0 0 0 4.95-2.475Z"
      fill="#1062D0"
    />
  </svg>
);

const Pencel = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M15.467 15.758h-9.6a.533.533 0 0 1 0-1.067h9.6a.534.534 0 0 1 0 1.067ZM.533 15.758a.534.534 0 0 1-.52-.656l.776-3.289a.527.527 0 0 1 .142-.254l9.806-9.806c.603-.604 1.658-.605 2.263 0l1.005 1.006c.303.302.469.704.469 1.131 0 .428-.166.83-.469 1.131L4.2 14.826a.534.534 0 0 1-.255.143l-3.289.775a.52.52 0 0 1-.123.014Zm1.26-3.553-.543 2.303 2.303-.543 9.698-9.698a.53.53 0 0 0 0-.754l-1.006-1.006a.546.546 0 0 0-.753 0l-9.7 9.698Zm2.029 2.245h.007-.007Z"
        fill="#1062D0"
      />
      <path
        d="M11.476 7.328a.529.529 0 0 1-.376-.156L8.585 4.657a.533.533 0 1 1 .755-.754l2.514 2.514a.534.534 0 0 1-.378.911Z"
        fill="#1062D0"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
